<template>
	<main :style="{ backgroundImage: `url(${backgroundUrl})` }" style="min-height: 550px;">
		<card>
			<v-layout justify-center>
				<v-card-title>
					<v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
					<v-divider class="mx-4" inset vertical></v-divider> 
					<b>{{ $t('error_page') }}</b>
				</v-card-title>
			</v-layout>
		</card>
	</main>
</template>

<script>
	import backgroundUrl from '@/assets/404.jpg'

	export default {
		data: () => ({
			backgroundUrl
		}),
		methods: {
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>